function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Copyright (c) 2020-2022 Estonian Information System Authority
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import Action from "../models/Action";
import ActionPendingError from "../errors/ActionPendingError";
import ActionTimeoutError from "../errors/ActionTimeoutError";
import ContextInsecureError from "../errors/ContextInsecureError";
import ExtensionUnavailableError from "../errors/ExtensionUnavailableError";
import config from "../config";
import { deserializeError } from "../utils/errorSerializer";

var WebExtensionService = /*#__PURE__*/function () {
  function WebExtensionService() {
    var _this = this;

    _classCallCheck(this, WebExtensionService);

    this.loggedWarnings = [];
    this.queue = [];
    window.addEventListener("message", function (event) {
      return _this.receive(event);
    });
  }

  _createClass(WebExtensionService, [{
    key: "receive",
    value: function receive(event) {
      var _this2 = this;

      var _a, _b, _c, _d, _e, _f;

      if (!/^web-eid:/.test((_a = event.data) === null || _a === void 0 ? void 0 : _a.action)) return;
      var message = event.data;
      var suffix = (_c = (_b = message.action) === null || _b === void 0 ? void 0 : _b.match(/success$|failure$|ack$/)) === null || _c === void 0 ? void 0 : _c[0];
      var initialAction = this.getInitialAction(message.action);
      var pending = this.getPendingMessage(initialAction);

      if (message.action === Action.WARNING) {
        (_d = message.warnings) === null || _d === void 0 ? void 0 : _d.forEach(function (warning) {
          if (!_this2.loggedWarnings.includes(warning)) {
            _this2.loggedWarnings.push(warning);

            console.warn(warning);
          }
        });
      } else if (pending) {
        switch (suffix) {
          case "ack":
            {
              clearTimeout(pending.ackTimer);
              break;
            }

          case "success":
            {
              this.removeFromQueue(initialAction);
              (_e = pending.resolve) === null || _e === void 0 ? void 0 : _e.call(pending, message);
              break;
            }

          case "failure":
            {
              var failureMessage = message;
              this.removeFromQueue(initialAction);
              (_f = pending.reject) === null || _f === void 0 ? void 0 : _f.call(pending, failureMessage.error ? deserializeError(failureMessage.error) : failureMessage);
              break;
            }
        }
      }
    }
  }, {
    key: "send",
    value: function send(message, timeout) {
      var _this3 = this;

      if (this.getPendingMessage(message.action)) {
        return Promise.reject(new ActionPendingError());
      } else if (!window.isSecureContext) {
        return Promise.reject(new ContextInsecureError());
      } else {
        var pending = {
          message: message
        };
        this.queue.push(pending);
        pending.promise = new Promise(function (resolve, reject) {
          pending.resolve = resolve;
          pending.reject = reject;
        });
        pending.ackTimer = window.setTimeout(function () {
          return _this3.onAckTimeout(pending);
        }, config.EXTENSION_HANDSHAKE_TIMEOUT);
        pending.replyTimer = window.setTimeout(function () {
          return _this3.onReplyTimeout(pending);
        }, timeout);
        window.postMessage(message, "*");
        return pending.promise;
      }
    }
  }, {
    key: "onReplyTimeout",
    value: function onReplyTimeout(pending) {
      var _a;

      this.removeFromQueue(pending.message.action);
      (_a = pending.reject) === null || _a === void 0 ? void 0 : _a.call(pending, new ActionTimeoutError());
    }
  }, {
    key: "onAckTimeout",
    value: function onAckTimeout(pending) {
      var _a;

      clearTimeout(pending.replyTimer);
      this.removeFromQueue(pending.message.action);
      (_a = pending.reject) === null || _a === void 0 ? void 0 : _a.call(pending, new ExtensionUnavailableError());
    }
  }, {
    key: "getPendingMessage",
    value: function getPendingMessage(action) {
      return this.queue.find(function (pm) {
        return pm.message.action === action;
      });
    }
  }, {
    key: "getInitialAction",
    value: function getInitialAction(action) {
      return action.replace(/-success$|-failure$|-ack$/, "");
    }
  }, {
    key: "removeFromQueue",
    value: function removeFromQueue(action) {
      var pending = this.getPendingMessage(action);
      clearTimeout(pending === null || pending === void 0 ? void 0 : pending.replyTimer);
      this.queue = this.queue.filter(function (pending) {
        return pending.message.action !== action;
      });
    }
  }]);

  return WebExtensionService;
}();

export { WebExtensionService as default };